import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { ChangePasswordModel, LoginUser } from '../../class-models/login-model';
import { Component, OnInit } from '@angular/core';
import { ApiResponse } from '../../class-models/ApiResponse';
import { AppServiceService } from 'src/app/app-service.service';
import { Customer, Unit } from 'src/app/user-details-model';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  isUnitConfig: boolean;
  isProdConfig: boolean;
  changepwdForm: UntypedFormGroup;
  user: LoginUser;
  flag1:boolean = false;
  isAuthenticated1 = false;
  selectedUnit: Unit;
  selectedCustomer: Customer;
  constructor(private router: Router,
    private messageService: MessageService,
    private appService: AppServiceService) { }

  ngOnInit(): void {
    this.initializeForm();
    this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
    this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    this.dropDownview();
  }
  dropDownview(){
    if(this.selectedUnit?.id != null && this.selectedCustomer?.customerId !=null){
      this.isProdConfig = false
      this.isUnitConfig = true
    }
    else if(this.selectedUnit?.id == null && this.selectedCustomer?.customerId !=null){
      this.isProdConfig = true
      this.isUnitConfig = false
    }
    else if(this.selectedUnit?.id == null && this.selectedCustomer?.customerId ==null){
      this.isProdConfig = false
      this.isUnitConfig = false
    }  
  }
  initializeForm() {
    this.changepwdForm = new UntypedFormGroup({
      oldpassword: new UntypedFormControl("", [
        Validators.required
      ]),
        password: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(8),
          
        ]),
        confirmpassword: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(8),
         
        ]),
    });
  }
  // passwordConfirming(c:AbstractControl):{invalid:boolean}{
  //   if(c.get('password').value !== c.get('confirmpassword').value){
  //     return {invalid:true};
  //   }
  // }
  onSubmit() {
    if (!this.changepwdForm.valid) {
      this.flag1 = true;      
      this.messageService.add({ severity: 'error', detail: "Must contain at least one number and one uppercase and lowercase letter and special character and at least 8 characters"});
      return;
    }
    else {
      this.flag1 = false;
    }
    var password = this.changepwdForm.controls["password"].value;
    var cpassword = this.changepwdForm.controls["confirmpassword"].value;
    if(password != cpassword){
      this.messageService.add({ severity: 'error', detail: "New Password and Confrim Password does not match." });
      return;
    }
    this.appService.user.subscribe(x => this.user = x);
    var loginModel: ChangePasswordModel = {
      userName: this.user.displayName,
      emailId: this.user.email,
      oldPassword: this.changepwdForm.controls["oldpassword"].value,
      newPassword: this.changepwdForm.controls["password"].value,
      isHmi: true
    }
      
    this.appService.ChangePassword(loginModel).subscribe((val: ApiResponse) => {     
      if (val != null && val.httpStatusCode === 200 ) {
        this.messageService.add({ severity: 'success', detail: val.responseMessage });
        setTimeout(() => {
          this.appService.logout();
        }, 2000);        
      } else{
        this.messageService.add({ severity: 'error', detail: val.responseMessage });
        return;
      }
    }, error => {
      this.messageService.add({ severity: 'error', detail: "something went wrong, please try again." });
      return;
    });
}
  OnReset(){
    this.changepwdForm.reset();
  }

  Navigate(){
    if (this.appService.getUserAccessLevel() == 1) {
      this.router.navigateByUrl('/product-admin');
    }
    else if (this.appService.getUserAccessLevel() == 2) {
      this.router.navigateByUrl('/user-module/kpi-comparison/kpi-dashboard');
    }
    else if (this.appService.getUserAccessLevel() == 3) {
      this.router.navigateByUrl('/user-module');
    }
    else if (this.appService.getUserAccessLevel() == 4) {
      this.router.navigateByUrl('/user-module');
    }
    else {
      this.router.navigateByUrl('/user-module/kpi-comparison/kpi-dashboard');
    }
  
  }
}

